import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const item = props => {
  const { value, description, onClick, selected } = props;

  return (
    <div className={ selected === true ? 'item selected' : 'item'} onClick={onClick}>
      {props.iconComponent}
      <div className="description">{description}</div>
      <div className="value"> {value}</div>
    </div>
  );
};

item.defaultProps = {
  onClick: () => null,
  selected: false,
};

item.propTypes = {
  value: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  iconComponent: PropTypes.any.isRequired,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
};

export default item;
